import { FC, useEffect, useState } from 'react';
import { urlParams } from '@lhb/func';
import { useMethods } from '@lhb/hook';
import { useGetShareContent } from '@/common/hook/useShareContent';
import styles from './entry.module.less';
import BasicLayout from '@/layout/BasicLayout';
import Detail from './index';

/**
 * 客流计数-点位详情
 */
const Component:FC<{}> = () => {

  /** 点位id */
  const [spotId, setSpotId] = useState('');

  useEffect(() => {
    const id = urlParams(location.search)?.id;
    if (id) {
      setSpotId(id);
    }
  }, []);

  const { shareId, shareParams } = useGetShareContent({ onSuccess: (params) => methods.init(params) });

  /** 分享时调用接口需要的数据，如果有值代表“分享时” */
  const shareData = shareId && shareParams ? { tenantId: shareParams?.tenantId, userId: shareParams?.employeeId } : null;

  const methods = useMethods({

    init(params) {
      setSpotId(params?.id);
    },

  });

  return (
    spotId ? <BasicLayout>
      <Detail id={spotId} shareData={shareData} className={styles.containerWrapper} />
    </BasicLayout> : <></>
  );
};

export default Component;
